/** Tamanhos disponíveis para o Spinner */
export type SpinnerSize = 'sm' | 'md' | 'lg';

/** Props do componente Spinner */
export interface SpinnerProps {
  readonly size?: SpinnerSize;
  readonly className?: string;
  readonly label?: string;
}

const SIZE_CLASSES: Record<SpinnerSize, string> = {
  sm: 'h-mini w-mini border-thin',
  md: 'h-xs w-xs border-thin',
  lg: 'h-md w-md border-thick',
};

/**
 * Componente Spinner — indicador de carregamento circular.
 *
 * @example
 * ```tsx
 * <Spinner size="md" label="Carregando..." />
 * ```
 */
export function Spinner({ size = 'md', className, label = 'Carregando...' }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label={label}
      className={[
        'border-base-neutral-black border-t-base-neutral-none animate-spin rounded-circular',
        SIZE_CLASSES[size],
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    />
  );
}
